<template>
<div class="">
  <div class="box-content--header container align-items-center justify-content-center hidden">
    <div class="box-content--header__img">
      <div class="img1 container align-items-center justify-content-center animation-bottom">
        <div class="img2 container align-items-center justify-content-center">
          <img src="@/assets/img/icon-words.svg" width="50" alt="Minds">
        </div>
      </div>
    </div>
    <div class="box-content--header__text flex-grow-1 flex-basis-400">
      <h2 class="animation-top animation-delay-02">MEU <span>PERFIL</span></h2>
      <hr class="header-text-hr animation-top animation-delay-02">
      <p class="animation-bottom animation-delay-04">Edite suas iformações.</p>
    </div>
  </div>
  <div class="box-content shadow-box box-content-border hidden">

    <div class="box--item animation-bottom animation-delay-05" style="position: relative;">
      <form class="form" @submit.prevent="update(form, student)">

        <div class="flex-grow-1 box-input">
          <div class="label">
            <label>Nome completo</label>
          </div>
          <div class="input-space container align-items-center">
            <div class="icons">
              <i class="fas fa-user"></i>
            </div>
            <input type="text" placeholder="Nome" class="input" v-model="form.name" disabled>
          </div>
        </div>

        <div class="flex-grow-1 box-input">
          <div class="label">
            <label>E-mail</label>
          </div>
          <div class="input-space container align-items-center">
            <div class="icons">
              <i class="fas fa-envelope"></i>
            </div>
            <input type="text" placeholder="email@email.com" class="input" v-model="form.email">
          </div>
        </div>
        <div class="flex-grow-1 container">
          <div class="flex-grow-1 box-input margin-right-5">
            <div class="label">
              <label>Data de Nascimento</label>
            </div>
            <div class="input-space container align-items-center">
              <div class="icons">
                <i class="fas fa-calendar"></i>
              </div>
              <input type="date" placeholder="10/10/2000" class="input" v-model="form.birth" disabled>
            </div>
          </div>
          <div class="flex-grow-1 box-input margin-left-5">
            <div class="label">
              <label>CPF</label>
            </div>
            <div class="input-space container align-items-center">
              <div class="icons">
                <i class="fas fa-user"></i>
              </div>
              <input type="text" placeholder="111.111.111-11" class="input" v-model="form.cpf" disabled>
            </div>
          </div>
        </div>
        <div class="flex-grow-1 box-input container justify-content-end">
          <button type="button" name="button" class="btn btn-yellow btn-rounded margin-right-10" :disabled="updating" @click.prevent="setUpdatePassword()">
            Alterar Senha
          </button>
          <button type="submit" name="button" class="btn btn-blue btn-rounded" :disabled="updating">
            Salvar alterações <i class="margin-left-5 fas fa-check"></i>
          </button>
        </div>
      </form>
      <modal ref="modal-password" :show="showModal">
        <div class="modal-password container justify-content-center align-items-center">
          <form class="modal-password-form container justify-content-center align-items-center" @submit.prevent="updatePassword(newPassword)">
            <div class="container">
              <input
                ref="password-input"
                class="input"
                :type="showPsswd ? 'text': 'password'"
                minlength="8"
                v-model="newPassword"
                required
              >
              <div
                class="show-password container justify-content-center align-items-center margin-left-10 margin-right-10"
                @click="showPsswd = !showPsswd"
              >
                <font-awesome-icon icon="eye" v-if="!showPsswd"/>
                <font-awesome-icon icon="eye-slash" v-else/>
              </div>
              <button
                class="btn btn-yellow btn-rounded"
                type="submit"
              >
                Alterar
              </button>
            </div>
          </form>
        </div>
      </modal>
    </div>
  </div>
</div>
</template>

<script type="text/javascript">
import { mapGetters } from 'vuex'

import modal from '@/components/modal'
import modalBus from '@/components/modal/modalBus'

export default {
  data() {
    return {
      updating: false,
      showModal: false,
      showPsswd: false,
      newPassword: ''
    }
  },
  computed: {
    ...mapGetters({
      student: 'student/GET',
      toReset: 'auth/toReset'
    }),
    form () {
      const student = this.student,
            dateObj = new Date(student.birth),
            year    = dateObj.getFullYear(),
            month   = dateObj.getMonth() + 1,
            day     = dateObj.getUTCDate()

      let cpf = student.cpf

      const first  = cpf.slice(0, 3),
            second = cpf.slice(3, 6),
            third  = cpf.slice(6, 9),
            final  = cpf.slice(9, 11)

      cpf = `${first}.${second}.${third}-${final}`

      return { name: student.name, email: student.email, cpf: cpf, birth: `${year}-${month >= 10 ? month : `0${month}`}-${day >= 10 ? day : `0${day}`}` }
    }
  },
  components: {
    modal
  },
  methods: {
    async update (form, student) {
      if (!this.updating) {
        try {
          this.updating = true

          this.$store.commit('setShowLoader', true)
          const toUpdate = {}

          for (const key in form) {
            if (!['birth', 'cpf'].includes(key)) {
              if (form[key] !== student[key]) toUpdate[key] = form[key]
            }
          }

          await this.$store.dispatch('student/update', toUpdate)
          if (this.toReset) {
            this.$store.commit('auth/setToReset', false)
            this.$store.dispatch('auth/logout')
          }
        } catch (error) {
          alert(typeof error == 'string' ? error : 'Failed to update profile!')
        } finally {
          this.updating = false
          this.$store.commit('setShowLoader', false)
        }
      }
    },
    async updatePassword (password) {
      if (!this.updating) {
        try {
          this.updating = true

          this.$store.commit('setShowLoader', true)

          await this.$store.dispatch('auth/updatePassword', password)

          this.$refs['modal-password'].close()
        } catch (error) {
          alert(typeof error == 'string' ? error : 'Failed to update password!')
        } finally {
          this.updating = false
          this.$store.commit('setShowLoader', false)
        }
      }
    },
    setUpdatePassword () {
      this.showModal = true
      this.newPassword = ''
    },
    close () {
      this.showModal = false
    }
  },
  mounted () {
    modalBus.$on('close', this.close)
  },
  beforeDestroy () {
    modalBus.$off('close', this.close)
  }
}
</script>

<style lang="scss" scoped>
.modal-password {
  height: 100%;
  width: 100%;
  &-form {
    width: 300px;
    height: 200px;

    input.input {
      background-color: #FFF;
      width: 275px;
      padding: 2px 10px;
    }

    .show-password {
      cursor: pointer;
      font-size: 25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/perfil/index.vue